export type TracklyRuntimeConfig = {
  ticketsApiBaseUrl?: string;
  workflowsApiBaseUrl?: string;
  azureAdClientId?: string;
  azureAuthority?: string;
};

declare global {
  interface Window {
    __TRACKLY_CONFIG__?: TracklyRuntimeConfig;
  }
}

// Runtime value (public/config.js, overwritten per environment at deploy time) wins;
// the build-time REACT_APP_* value is the fallback for local dev and Jest.
function resolve(key: keyof TracklyRuntimeConfig, envValue: string | undefined): string | undefined {
  const runtimeValue = typeof window === 'undefined' ? undefined : window.__TRACKLY_CONFIG__?.[key];
  return typeof runtimeValue === 'string' && runtimeValue !== '' ? runtimeValue : envValue;
}

export const getTicketsApiBaseUrl = () =>
  resolve('ticketsApiBaseUrl', process.env.REACT_APP_Tickets_API_BASE_URL);

export const getWorkflowsApiBaseUrl = () =>
  resolve('workflowsApiBaseUrl', process.env.REACT_APP_Workflows_API_BASE_URL);

export const getAzureAdClientId = () =>
  resolve('azureAdClientId', process.env.REACT_APP_AZURE_AD_CLIENT_ID);

export const getAzureAuthority = () =>
  resolve('azureAuthority', process.env.REACT_APP_AZURE_AUTHORITY);
